import styled from 'styled-components'
import RoomChargeIcon from '../../../../img/svg/roomCharge'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const SelectSummaryRow = styled.div`
	display: flex;
	align-items: center;
	gap: 0.43em;
	font-size: 1em;
	color: ${colorTheme.roomCharge.modal.label};
`
SelectSummaryRow.displayName = 'SelectSummaryRow'

export const SelectSummaryIcon = styled(RoomChargeIcon)`
	flex-shrink: 0;
	width: 1.37em;
	height: 1.25em;
`
SelectSummaryIcon.displayName = 'SelectSummaryIcon'

export const SelectLimitRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.62em 0.93em;
	border-radius: 1.25em;
	background: ${colorTheme.roomCharge.modal.limit.within.background};
	color: ${colorTheme.roomCharge.modal.limit.within.text};

	&.exceeded {
		background: ${colorTheme.roomCharge.modal.limit.exceeded.background};
		color: ${colorTheme.roomCharge.modal.limit.exceeded.text};
	}
`
SelectLimitRow.displayName = 'SelectLimitRow'

export const SelectLimitLabel = styled.span`
	display: flex;
	align-items: center;
	gap: 0.62em;
	font-size: 1em;
`
SelectLimitLabel.displayName = 'SelectLimitLabel'

export const SelectLimitDot = styled.span`
	flex-shrink: 0;
	width: 0.75em;
	height: 0.75em;
	border-radius: 50%;
	background: ${colorTheme.roomCharge.modal.limit.within.dot};

	&.exceeded {
		background: ${colorTheme.roomCharge.modal.limit.exceeded.dot};
	}
`
SelectLimitDot.displayName = 'SelectLimitDot'

export const SelectLimitValue = styled.span`
	font-size: 1.12em;
	font-weight: 500;
`
SelectLimitValue.displayName = 'SelectLimitValue'

export const SelectGuestList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.62em;
`
SelectGuestList.displayName = 'SelectGuestList'

export const SelectGuestButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.62em;
	padding: 0.93em;
	border: 1px solid ${colorTheme.roomCharge.modal.guest.border};
	border-radius: 0.75em;
	text-align: left;
	transition: all 0.2s;
	background: ${colorTheme.roomCharge.modal.guest.background};

	&:hover:not(:disabled) {
		border-color: ${colorTheme.roomCharge.modal.guest.hoverBorder};
	}

	&:disabled {
		cursor: not-allowed;
		background: ${colorTheme.roomCharge.modal.guest.disabled.background};
	}
`
SelectGuestButton.displayName = 'SelectGuestButton'

export const SelectGuestInfo = styled.span`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 0.12em;
	min-width: 0;
`
SelectGuestInfo.displayName = 'SelectGuestInfo'

export const SelectGuestNameRow = styled.span`
	display: flex;
	align-items: center;
	gap: 0.43em;
`
SelectGuestNameRow.displayName = 'SelectGuestNameRow'

export const SelectGuestName = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 1em;
	font-weight: 600;
	color: ${colorTheme.roomCharge.modal.guest.name};

	&.blocked {
		color: ${colorTheme.roomCharge.modal.guest.disabled.name};
	}
`
SelectGuestName.displayName = 'SelectGuestName'

export const SelectGuestRoomBadge = styled.span`
	flex-shrink: 0;
	padding: 0.12em 0.43em;
	border-radius: 0.62em;
	font-size: 0.75em;
	background: ${colorTheme.roomCharge.modal.guest.roomBadge.background};
	color: ${colorTheme.roomCharge.modal.guest.roomBadge.text};
`
SelectGuestRoomBadge.displayName = 'SelectGuestRoomBadge'

export const SelectGuestStatus = styled.span`
	display: flex;
	align-items: center;
	gap: 0.31em;
	font-size: 0.87em;
	color: ${colorTheme.roomCharge.modal.guest.eligible};

	&.blocked {
		color: ${colorTheme.roomCharge.modal.guest.blocked};
	}
`
SelectGuestStatus.displayName = 'SelectGuestStatus'

export const SelectGuestStatusIcon = styled(RoomChargeIcon)`
	flex-shrink: 0;
	width: 0.93em;
	height: 0.93em;
`
SelectGuestStatusIcon.displayName = 'SelectGuestStatusIcon'

export const SelectGuestChevron = styled(RoomChargeIcon)`
	flex-shrink: 0;
	width: 0.68em;
	height: 1.25em;
	color: ${colorTheme.roomCharge.modal.guest.chevron};
`
SelectGuestChevron.displayName = 'SelectGuestChevron'
